
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'PreLoader'
})
export default class PreLoader extends Vue {}
